import { render } from "./PageInbox.vue?vue&type=template&id=ea8abb04&scoped=true"
import script from "./PageInbox.vue?vue&type=script&lang=js"
export * from "./PageInbox.vue?vue&type=script&lang=js"

import "./PageInbox.vue?vue&type=style&index=0&id=ea8abb04&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8abb04"]])

export default __exports__